module.exports = __webpack_public_path__ + "images/emoji/running.fcce534dcfdb6071cc7b.png";